import { render, staticRenderFns } from "./r-booster-dialog.vue?vue&type=template&id=a7a3f2cc&scoped=true"
import script from "./r-booster-dialog.vue?vue&type=script&lang=js"
export * from "./r-booster-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-booster-dialog.vue?vue&type=style&index=0&id=a7a3f2cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a3f2cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7a3f2cc')) {
      api.createRecord('a7a3f2cc', component.options)
    } else {
      api.reload('a7a3f2cc', component.options)
    }
    module.hot.accept("./r-booster-dialog.vue?vue&type=template&id=a7a3f2cc&scoped=true", function () {
      api.rerender('a7a3f2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/booster/r-booster-dialog.vue"
export default component.exports